class AlgoliaCustomBadges extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
    * Initializes settings based on custom attributes when the element is connected to the DOM.
    * @returns {void}
    */
  connectedCallback() {
    this.settings = {
      customBadges: JSON.parse(this.getAttribute('custom-badges')),
      badgePosition: this.getAttribute('badge-position'),
      saleBadgeAllCaps: this.getAttribute('sale-badge-all-caps').toLowerCase() === 'true',
      saleBadgeBorderColor: this.getAttribute('sale-badge-border-color'),
      saleBadgeBorderRadius: this.getAttribute('sale-badge-border-radius'),
      saleBadgeBorderWidth: this.getAttribute('sale-badge-border-width'),
      saleBadgeFillColor: this.getAttribute('sale-badge-fill-color'),
      saleBadgeFontSize: this.getAttribute('sale-badge-font-size'),
      saleBadgePaddingX: this.getAttribute('sale-badge-padding-x'),
      saleBadgePaddingY: this.getAttribute('sale-badge-padding-y'),
      saleBadgeTextColor: this.getAttribute('sale-badge-text-color'),
      saleBadgeRenderLocation: this.getAttribute('sale-badge-render-location'),
      customBadgesSeparation: this.getAttribute('custom-badges-separation')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      #product__badge * {
        color: ${this.settings.saleBadgeTextColor};
      }

      .product__badge {
        display: inline-block;
        text-align: center;
        z-index: 1;
        margin: 0;
        background-color: ${this.settings.saleBadgeFillColor};
        border-radius: ${this.settings.saleBadgeBorderRadius}px;
        border-width: ${this.settings.saleBadgeBorderWidth}px;
        border: 1px solid ${this.settings.saleBadgeFillColor};
        color: ${this.settings.saleBadgeTextColor};
        padding-block: ${this.settings.saleBadgePaddingY}px;
        padding-inline: ${this.settings.saleBadgePaddingX}px;
      }

      .product__badge span {
        white-space: nowrap;
        text-transform: ${this.settings.saleBadgeAllCaps ? 'uppercase' : ''};
      }

      .product__badge--top {
        top: 0;
      }

      .product__badge--bottom {
        bottom: 0;
      }

      .product__badge--left {
        left: 0;
      }

      .product__badge--center {
        left: 50%;
        transform: translateX(-50%);
      }

      .product__badge--right {
        right: 0;
      }
    `;

    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Retrieves the custom badges from the given item's metadata.
   * @param {Object} item - The item object containing metadata.
   * @returns {Array} The extracted badges from the item's metadata.
   */
  getCustomBadges(item) {
    return this.settings.customBadges?.filter(
      badge => item?.tags?.some(
        tag => tag?.toLowerCase().trim() === badge.tagName.toLowerCase().trim(),
      ),
    );
  }

  /**
   * Renders the custom badges content.
   * @param {Array} item - The item object containing metadata.
   * @returns {string} The HTML string with the custom badges.
   */
  render(item, isMixedStyles) {
    const customBadges = this.getCustomBadges(item);
    const style = this.getStyle();
    // This condition is to prevent overlapping "Hidden Gems" badge
    const html = customBadges.map(({ badgeText }, i) => {
      const badgeDiv = document.createElement('div');
      badgeDiv.classList.add('product__badge', this.settings.saleBadgeFontSize);
      if (this.settings.badgePosition) {
        // this setting can be values like 'bottom left'
         if(this.settings.saleBadgeRenderLocation === 'product_info') {
          badgeDiv.classList.add('product__badge--bottom');
         } else {
          this.settings.badgePosition.split(' ').forEach(position => badgeDiv.classList.add(`product__badge--${position}`));
        }
      }
      badgeDiv.style.top = isMixedStyles ? `${3 + i * this.settings.customBadgesSeparation}rem` : '';

      const innerDiv = document.createElement('div');
      const span = document.createElement('span');
      span.textContent = badgeText;
      innerDiv.appendChild(span);
      badgeDiv.appendChild(innerDiv);

      return [style, badgeDiv];
    });
    return html;
  }
}

customElements.define("algolia-custom-badges", AlgoliaCustomBadges);